import { useEffect, useRef, useState } from 'react'
import { CircularProgress, Container } from '@mui/material'
import { useApiExam } from '../../api'
import Quiz from './Quiz'
import Countdown from 'react-countdown'

export default function ExamQuestions() {
   const [loading, setLoading] = useState(true)
   const [questionsData, setQuestionsData] = useState(null)

   const { get_exam } = useApiExam()

   useEffect(() => {
      get_exam('/exam/questions')
         .then((res) => {
            setQuestionsData(res)
         })
         .catch((err) => {
            console.error('Error fetching exam questions:', err)
         })
         .finally(() => setLoading(false))
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   // Custom renderer supaya bisa kontrol saat selesai
   const renderer = ({ minutes, seconds, completed }) => {
      if (completed) {
         return <span>Mengalihkan ke halaman hasil ujian...</span>
      } else {
         return (
            <span>
               Otomatis mengirim jawaban dalam {minutes}:
               {seconds.toString().padStart(2, '0')}
            </span>
         )
      }
   }

   const quizRef = useRef()

   return (
      <Container sx={{ mt: 5, textAlign: 'center' }}>
         {loading ? (
            <CircularProgress />
         ) : (
            <>
               <Quiz ref={quizRef} data={questionsData} />
               <Countdown
                  onComplete={() => {
                     if (quizRef.current) {
                        quizRef.current.handleSubmit()
                     }
                  }}
                  date={Date.now() + 10 * 1000} // 1 menit
                  renderer={renderer}
               />
            </>
         )}
      </Container>
   )
}
